import {
	DateFormatter,
	getOffsetInformation,
	parseIsoDate
} from '../../molecules/time-formatter/time-formatter';

/**
 * Gets uncommented script tag, parses its `preset-data` data attribute,
 * changes `eventeventdate`, `eventeventenddate`, `eventeventdateical` and `eventeventenddateical` parameters to match client's date format
 * and calculates client's UTC offset
 *
 * @param {Element} container - `off-canvas__content` with a script tag specific for a single webinar/event
 */
export const formatWebinarDate = container => {
	const scriptElement = container.querySelector('script[data-preset-data]');

	if (scriptElement) {
		const data = scriptElement.getAttribute('data-preset-data');
		const parsed = JSON.parse(data);

		if (parsed.eventeventdate) {
			const defaultDateTimeFormat = 'YYYY-MM-DD HH:mm ([GMT]ZZ) ';

			const eventStartDate = parseIsoDate(parsed.eventeventdate);
			parsed.eventeventdate = DateFormatter.format(
				eventStartDate,
				parsed.eventoutputDateTimeFormat || defaultDateTimeFormat
			);

			parsed.eventeventtimezone = parsed.eventeventtimezone || getOffsetInformation(eventStartDate);

			if (parsed.eventeventenddate) {
				const eventEndDate = parseIsoDate(parsed.eventeventenddate);
				parsed.eventeventenddate = DateFormatter.format(
					eventEndDate,
					parsed.eventoutputDateTimeFormat || defaultDateTimeFormat
				);
			}

			const iCalDateTimeFormat = 'YYYY-MM-DDTHH:mm';

			if (parsed.eventeventdateical) {
				const eventDateICal = parseIsoDate(parsed.eventeventdateical);
				parsed.eventeventdateical = DateFormatter.format(eventDateICal, iCalDateTimeFormat);
			}

			if (parsed.eventeventenddateical) {
				const eventEndDateICal = parseIsoDate(parsed.eventeventenddateical);
				parsed.eventeventenddateical = DateFormatter.format(eventEndDateICal, iCalDateTimeFormat);
			}

			if (parsed.eventstartdate) {
				const defaultDateFormat = 'YYYY-MM-DD ';
				const defaultTimeFormat = 'HH:mm ([GMT]ZZ) ';
				const startDate = parseIsoDate(parsed.eventstartdate);
				parsed.eventstartdate = DateFormatter.format(
					startDate,
					parsed.eventoutputDateFormat || defaultDateFormat
				);
				if (parsed.eventenddate) {
					const endDate = parseIsoDate(parsed.eventenddate);
					parsed.eventenddate = DateFormatter.format(
						endDate,
						parsed.eventoutputDateFormat || defaultDateFormat
					);
				}
				if (parsed.eventstarttime) {
					const startTime = parseIsoDate(parsed.eventstarttime);
					parsed.eventstarttime = DateFormatter.format(
						startTime,
						parsed.eventoutputTimeFormat || defaultTimeFormat
					);
				}
				if (parsed.eventendtime) {
					const endTime = parseIsoDate(parsed.eventendtime);
					parsed.eventendtime = DateFormatter.format(
						endTime,
						parsed.eventoutputTimeFormat || defaultTimeFormat
					);
				}
			}
			const presetData = JSON.stringify(parsed);
			scriptElement.setAttribute('data-preset-data', presetData);
		}
	}
};
